/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';
import { CommunityDto } from '../../communities/community.dto';
import { ContactDetailsCommunicationDataDto } from './contact-details-communication.dto';
import {
  ContactDeliveryMethod,
  ContactDetailsCustomFieldListDto,
  ContactDetailsPaymentPayerDto,
  ContactDetailsTermsPayerDto,
} from './contact-details-shared.dto';
import { ID } from '@gh/common-shared-data';

export const ContactCustomerType = createEnum('TYPE_OF_CUSTOMER', {
  Other: 'OTHER',
  FirstHomeBuyer: 'FIRST_HOME_BUYER',
  Realtor: 'REALTOR',
  Investor: 'INVESTOR',
  EmptyNester: 'EMPTY_NESTER',
  SecondThirdHomeBuyer: 'SECOND_THIRD_HOME_BUYER',
  MultiUnitInvestor: 'MULTI_UNIT_INVESTOR',
  SecondaryDwelling: 'SECONDARY_DWELLING',
  BuildingSmallerHome: 'BUILDING_SMALLER_HOME',
  BuildingBiggerHome: 'BUILDING_BIGGER_HOME',
  KnockDownRebuild: 'KNOCKDOWN_REBUILD',
});

export type ContactCustomerType = EnumSet<typeof ContactCustomerType>;

export const ContactInvitationStatus = createEnum('INVITATION_STATUS', {
  Invited: 1,
  Activated: 2,
  Deactivated: 3,
});

export type ContactInvitationStatus = EnumSet<typeof ContactInvitationStatus>;

export type ContactDetailsInvitationSubTabDto = {
  invitationEmail: string;
  invitationId: ID;
  invitationStatus: EnumSet<typeof ContactInvitationStatus>;
};

export type ContactReferredByLib = {
  code: string;
  itemCode: string;
  localization: string;
};

export type ContactDetailsCustomerBillingDto = {
  deliveryBy: ContactDeliveryMethod;
  isBillingSame: boolean;
  country: string;
  addressee: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  stateCode: string;
  postcode: string;
  email: string;
};

export type ContactDetailsCustomerReferredByDto = {
  marketingOptIn: boolean;
  referredBy: any;
  referredDetails: string;
  community: CommunityDto;
};

export type ContactDetailsCustomerCommonDto = {
  billing: ContactDetailsCustomerBillingDto;
  referredBy: ContactDetailsCustomerReferredByDto;
};

export type ContactDetailsCustomerKidDto = {
  name?: string;
  dateOfBirth?: Date;
};

export type ContactDetailsCustomerBirthdaysDto = {
  partnerName?: string;
  partnerDateOfBirth?: Date;
  parent1Name?: string;
  parent1DateOfBirth?: Date;
  parent2Name?: string;
  parent2DateOfBirth?: Date;
  kids: ContactDetailsCustomerKidDto[];
};

export type ContactDetailsCustomerAdditionalDetailsDto = {
  dateOfBirth?: Date;
  additionalDatesOfBirth?: ContactDetailsCustomerBirthdaysDto;
  websiteLead: boolean;
};

export type ContactDetailsCustomerDto = {
  common: ContactDetailsCustomerCommonDto;
  payment: ContactDetailsPaymentPayerDto;
  terms: ContactDetailsTermsPayerDto;
  communication: ContactDetailsCommunicationDataDto;
  customFields: ContactDetailsCustomFieldListDto;
  invitations: ContactDetailsInvitationSubTabDto[];
  additionalDetails: ContactDetailsCustomerAdditionalDetailsDto;
};
